<template>
  <div id="detail">
    <!-- 兑换详情 -->
    <header>
      <img src="@/static/images/other/chenggong.png" alt="" class="chenggong" />
      <p class="big-title">恭喜您，福利领取成功。</p>
      <p class="tip">
        领取后服务将发放至“我的<span v-if="type == 0">趣豆</span><span v-if="type == 1">礼包</span>”，<br />
        使用/查看福利相关信息。
      </p>
    </header>
    <div class="result">
      <!-- 卡券 -->
      <table border="1" v-if="type == 1">
        <tr class="head">
          <td>卡券名称</td>
          <td>卡券面值（元）</td>
          <td>张数</td>
        </tr>
         <tr v-for="(item,index) in cardMapList" :key="index">
          <td>{{item.name}}</td>
          <td>{{item.amount}}</td>
          <td>1</td>
        </tr>
        <!-- <tr>
          <td>汽车检测服务卡</td>
          <td>200</td>
          <td>45</td>
        </tr>
        <tr>
          <td>车身防锈检测</td>
          <td>200</td>
          <td>45</td>
        </tr> -->
      </table>
      <!-- 趣豆 -->
      <p class="code green" v-if="type == 0">+{{ ticketScore }}趣豆</p>
    </div>
    <div class="btn">
      <mt-button size="large" v-if="type == 0" type="primary" @click="changeRouter('/')">查看/使用</mt-button>
      <mt-button size="large" v-if="type == 1" type="primary" @click="changeRouter('/gifts')">查看/使用</mt-button>
    </div>
  </div>
</template>

<script>
 
export default {
  data() {
    return {
      type: "-1", //卡券1   趣豆0
      id: "",
      ticketScore: "",
      ticketType: "0",
      cardMapList: [],
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getDetail();
  },
  methods: {
    //获取兑换详情    getDetail
    getDetail() {
      this.post(this.apis.getDetail, {
        activationCode: this.id,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.type = response.data.ticketType;
            this.ticketScore = response.data.ticketScore;
            this.cardMapList = response.data.cardMapList;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
#detail {
  padding-top: 82px;
  padding-bottom: 50px;
  header {
    text-align: center;
    .chenggong {
      width: 189px;
      height: 158px;
    }
    .big-title {
      font-family: PingFang-SC-Heavy;
      font-size: 30px;
      line-height: 36px;
      color: #66906a;
      padding-bottom: 20px;
      font-weight: bold;
    }
    .tip {
      font-family: PingFang-SC-Medium;
      font-size: 24px;
      line-height: 35px;
      color: #878787;
    }
  }
  .result {
    padding-top: 68px;
    padding-bottom: 73px;
    table {
      margin: 0 auto;
      width: 626px;
      height: 203px;
      background-color: #ffffff;
      border: solid 1px #1fbe6e;
      text-align: center;
      .head {
        font-family: PingFang-SC-Medium;
        font-size: 24px;
        color: #067e42;
      }
      td {
        height: 66px;
      }
    }
    .code {
      font-family: PingFang-SC-Bold;
      font-size: 34px;
      font-weight: bold;
      text-align: center;
    }
  }
  .btn {
    margin: 0 auto;
    width: 611px;
  }
}
</style>
